import type { Grid } from '@/core/Game/types'

export function getNeighborGridAt(gridWithMargins: Grid, y: number, x: number): Grid {
  return gridWithMargins.slice(y, y + 3).map(row => row.slice(x, x + 3))
}
